import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export function getFormControlType(
    control: AbstractControl,
): typeof FormGroup | typeof FormControl {
    return (control as FormGroup).addControl ? FormGroup : FormControl;
}
